import { Companion_getInstance10dt578q09swj as Companion_getInstance } from './Instant.mjs';
import { numberToLong2pakxeg38estk as numberToLong } from '../js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function systemClockNow() {
  return Companion_getInstance().xh(numberToLong((new Date()).getTime()));
}
//region block: exports
export {
  systemClockNow as systemClockNowmqi0s7hoicxq,
};
//endregion

//# sourceMappingURL=InstantJs.mjs.map
